import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { Box, Dialog, Skeleton } from "@mui/material";
import { useState } from "react";

interface ReportCardMediaProps {
  url: string;
  type: "photo" | "video";
  fullWidth?: boolean;
}

export default function ReportCardMedia({
  url,
  type,
  fullWidth,
}: ReportCardMediaProps) {
  const [loaded, setLoaded] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const height = fullWidth ? 320 : 140;

  return (
    <>
      <Box
        onClick={() => setLightboxOpen(true)}
        sx={{
          position: "relative",
          cursor: "pointer",
          overflow: "hidden",
          width: "100%",
          ...(fullWidth
            ? { borderRadius: 0 }
            : { borderRadius: 1, maxWidth: 280, mt: 1 }),
        }}
      >
        {!loaded && (
          <Skeleton
            variant="rectangular"
            sx={{
              width: "100%",
              height,
              ...(fullWidth ? {} : { borderRadius: 1 }),
            }}
          />
        )}
        {type === "photo" ? (
          <img
            src={url}
            alt="Surf conditions"
            onLoad={() => setLoaded(true)}
            style={{
              width: "100%",
              height,
              objectFit: "cover",
              borderRadius: fullWidth ? 0 : 4,
              display: loaded ? "block" : "none",
            }}
          />
        ) : (
          <Box sx={{ position: "relative" }}>
            <video
              src={url}
              onLoadedData={() => setLoaded(true)}
              style={{
                width: "100%",
                height,
                objectFit: "cover",
                borderRadius: fullWidth ? 0 : 4,
                display: loaded ? "block" : "none",
              }}
            />
            <PlayCircleIcon
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: fullWidth ? 56 : 40,
                color: "rgba(255,255,255,0.8)",
                pointerEvents: "none",
              }}
            />
          </Box>
        )}
      </Box>

      <Dialog
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "visible",
          },
        }}
      >
        {type === "photo" ? (
          <img
            src={url}
            alt="Surf conditions"
            style={{ maxWidth: "90vw", maxHeight: "80vh", borderRadius: 8 }}
          />
        ) : (
          <video
            src={url}
            controls
            autoPlay
            style={{ maxWidth: "90vw", maxHeight: "80vh", borderRadius: 8 }}
          />
        )}
      </Dialog>
    </>
  );
}
